var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTomatillo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 493,
    viewBox: "0 0 493 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493 265.111C493 390.971 382.638 493 246.5 493C110.362 493 0 390.971 0 265.111C0 139.251 119.274 76.5142 246.5 139.379C365.774 52.9365 493 139.251 493 265.111Z",
    fill: "#72AC39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.949 52.0931L254.474 118.574L340.535 0L294.49 137.392L387.062 123.505L294.49 162.951L256.46 204.754L198.949 162.951L98.127 134.172L200.936 138.272L198.949 52.0931Z",
    fill: "#407010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.491 166.189C155.039 183.315 100.418 209.204 78.2066 241.041C55.9953 272.878 81.6927 312.036 57.1449 294.911C32.597 277.785 33.2865 233.994 55.4978 202.157C77.7091 170.32 105.943 149.063 130.491 166.189Z",
    fill: "#F5FFD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomatillo);
export default __webpack_public_path__ + "static/media/tomatillo.a6e7da17bda276f45cfb3f38e8a452ac.svg";
export { ForwardRef as ReactComponent };